/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,

  LOAD_OBS_LIST,
  LOAD_OBS_LIST_SUCCESS,
  LOAD_OBS_LIST_ERROR,

  UPDATE_OBS_LIST,
  UPDATE_OBS_LIST_SUCCESS,
  UPDATE_OBS_LIST_ERROR,

  
  DELETE_OBS,
  DELETE_OBS_ERROR,
  DELETE_OBS_SUCCESS,

  ADD_FOLLOWUP,
  ADD_FOLLOWUP_SUCCESS,
  ADD_FOLLOWUP_ERROR,

  LOAD_FOLLOWUP,
  LOAD_FOLLOWUP_SUCCESS,
  LOAD_FOLLOWUP_ERROR,

  UPDATE_LEAVE_LIST,
  UPDATE_LEAVE_LIST_SUCCESS,
  UPDATE_LEAVE_LIST_ERROR,
  UPDATE_LPND_STATUS,
  UPDATE_LPND_STATUS_SUCCESS,
  UPDATE_LPND_STATUS_ERROR,
  DELETE_RECORD,
  DELETE_RECORD_ERROR,
  DELETE_RECORD_SUCCESS,



   //  Apply Leave Details
   APPLY_LEAVE_DETAILS,
   APPLY_LEAVE_DETAILS_SUCCESS,
   APPLY_LEAVE_DETAILS_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(obsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    obsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}
export function addFollowUp(submitFollowUp) {
  return {
    type:ADD_FOLLOWUP,
    submitFollowUp,
  }
}


export function loadFollowUp(obsImportId) {
  return {
    type: LOAD_FOLLOWUP,
    obsImportId,
  }
}

export function loadFollowUpSuccess(followup_list) {
  return {
    type: LOAD_FOLLOWUP_SUCCESS,
    followup_list,
  }
}

export function loadFollowUpError(error) {
  return {
    type: LOAD_FOLLOWUP_ERROR,
    error,
  }
}
export function addFollowUpSuccess(submitFollowUp, success) {
  return {
    type: ADD_FOLLOWUP_SUCCESS,
    submitFollowUp,
    success,
  }
}

/**
 * @param {string} error
 */

export function addFollowUpError(error) {
  return {
    type:ADD_FOLLOWUP_ERROR,
    error,
  }
}
/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}


export function loadObsList(searchFilter) {
  return {
    type: LOAD_OBS_LIST,
    searchFilter,
    
  }
}

export function loadObsListSuccess(obs_list) {
  return {
    type: LOAD_OBS_LIST_SUCCESS,
    obs_list,
  }
}

/**
 * @param {string} error
 */

export function loadObsListError(error) {
  return {
    type: LOAD_OBS_LIST_ERROR,
    error,
  }
}
//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */

//Employee list Update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateLeaveList(leaveDetails) {
  return {
    type: UPDATE_LEAVE_LIST,
    leaveDetails,
  }
}

export function updateLeaveListSuccess(leaveDetails, success) {
  return {
    type: UPDATE_LEAVE_LIST_SUCCESS,
    leaveDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateLeaveListError(error) {
  return {
    type: UPDATE_LEAVE_LIST_ERROR,
    error,
  }
}

//LPND status Update
/**
 *
 * @param {integer} id
 * @returns
 */
export function updateLpndStatus(statusDetails) {
  return {
    type: UPDATE_LPND_STATUS,
    statusDetails,
  }
}

export function updateLpndStatusSuccess(statusDetails, success) {
  return {
    type: UPDATE_LPND_STATUS_SUCCESS,
    statusDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateLpndStatusError(error) {
  return {
    type: UPDATE_LPND_STATUS_ERROR,
    error,
  }
}

export function deleteRecord(leaveData) {
  return {
    type: DELETE_RECORD,
    leaveData,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteRecordSuccess(leaveData, success) {
  return {
    type: DELETE_RECORD_SUCCESS,
    leaveData,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteRecordError(error) {
  return {
    type: DELETE_RECORD_ERROR,
    error,
  }
}

//Apply leave details
/**
 *
 * @param {integer} id
 * @returns
 */
export function applyLeaveList(applyLeaveDetails) {
  return {
    type: APPLY_LEAVE_DETAILS,
    applyLeaveDetails,
  }
}

export function applyLeaveListSuccess(applyLeaveDetails, success) {
  return {
    type: APPLY_LEAVE_DETAILS_SUCCESS,
    applyLeaveDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function applyLeaveListError(error) {
  return {
    type: APPLY_LEAVE_DETAILS_ERROR,
    error,
  }
}


export function updateObsList(obsDetails) {
  return {
    type: UPDATE_OBS_LIST,
    obsDetails,
  }
}

export function updateObsListSuccess(obsDetails, success) {
  return {
    type: UPDATE_OBS_LIST_SUCCESS,
    obsDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function updateObsListError(error) {
  return {
    type: UPDATE_OBS_LIST_ERROR,
    error,
  }
}



export function deleteObs(deleteData) {
  return {
    type: DELETE_OBS,
    deleteData,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function deleteObsSuccess(deleteData, success) {
  return {
    type: DELETE_OBS_SUCCESS,
    deleteData,
    success,
  }
}

/**
 * @param {string} error
 */
export function deleteObsError(error) {
  return {
    type: DELETE_OBS_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  loadObsList,
  loadObsListSuccess,
  loadObsListError,
  //Leave list
  updateLeaveList,
  updateLeaveListSuccess,
  updateLeaveListError,
  //LPND status list
  updateLpndStatus,
  updateLpndStatusSuccess,
  updateLpndStatusError,

  deleteRecord,
  deleteRecordSuccess,
  deleteRecordError,

  applyLeaveList,
  applyLeaveListSuccess,
  applyLeaveListError,

  updateObsList,
  updateObsListSuccess,
  updateObsListError,
  

  deleteObs,
  deleteObsSuccess,
  deleteObsError,

  addFollowUp,
  addFollowUpSuccess,
  addFollowUpError,

  loadFollowUp,
  loadFollowUpSuccess,
  loadFollowUpError

}

export default actions
